import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { environment } from './../../environments/environment';
import { NgIf } from '@angular/common';

@Component({
  standalone: false,  // this is now required when using NgModule
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  public domain: string = environment.domain;
  public ftepUrl: string = environment.ftepUrl;
  public helpdeskUrl: string = environment.helpdeskUrl;
  public version: string = environment.version;

  constructor(public userService: UserService) { }

  ngOnInit(): void {
  }

  isActive(route: string) {
    return route === location.hash;
  };  
}
